import React from 'react';
import Card from '../../../components/card';
import icons from '../../../assets/icons';
import './styles.scss';

const SiteGroupCard = ({ siteGroup, selectedSiteGroup, onSelect }) => {
  const displayName = siteGroup.displayName ? siteGroup.displayName : '--';

  const company = siteGroup.companyDisplayName ? siteGroup.companyDisplayName : '--';
  const count = siteGroup.sitesCount > 0 ? siteGroup.sitesCount : siteGroup.devicesCount;
  let footerLabel = siteGroup.sitesCount > 0 ? 'site' : 'device';

  if (siteGroup.devicesCount === 0) {
    footerLabel = 'site';
  }

  return (
    <Card
      classes={selectedSiteGroup && siteGroup.id === selectedSiteGroup.id ? 'selected' : ''}
      header={
        <div>
          <h3>{displayName}</h3>
        </div>
      }
      body={
        <div className="d-flex flex-column">
          <h4 id={`site-group-owner-${siteGroup.ownerEmail || '--'}`}>
            <b>Owner:</b> {siteGroup.ownerEmail || '--'}
          </h4>
          <h4 id={`site-group-company-${company}`}>
            <b>Company:</b> {company}
          </h4>
        </div>
      }
      footer={
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <img className={'blue-icon'} src={icons.projectOutline} alt="projects" />
            <h5>{`${count} ${count > 1 ? `${footerLabel}s` : footerLabel}`}</h5>
          </div>
          {/* { hasIntegration && (
            <div className="d-flex align-items-center">
              <img className={'blue-icon'} src={icons.integrations} alt="integrations" />
              <h5>CMS integration</h5>
            </div>
          )} */}
        </div>
      }
      onPress={() => {
        onSelect(siteGroup);
      }}
    />
  );
};

export default SiteGroupCard;
